/* Elite Games Landing (light) — shared JS
 * Provides: search-filter, cart (local), toast, FAQ single-open, reviews scroll, smooth scroll
 * Listens at document level so any section can drop in markup with data-attrs.
 */
(function () {
  if (window.__EGL_BOOTED) return;
  window.__EGL_BOOTED = true;

  document.body.classList.add('egl-active');

  /* ========== Portal del carrito al <body> ==========
   * eg-gaming.css le da 'position:relative; z-index:1' a toda .shopify-section.
   * Eso encierra al drawer en el contexto de apilamiento de la seccion del
   * header, donde su z-index 95 no puede competir con #MainContent (z-index 1,
   * pero posterior en el DOM). Resultado: el carrito se abria DETRAS de la
   * pagina. Los tres son position:fixed, asi que moverlos al body no los
   * convierte en items del grid del layout.
   */
  function portalToBody(sel) {
    var nodes = document.querySelectorAll(sel);
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      if (el.parentElement !== document.body) document.body.appendChild(el);
    });
    // Al recargar una seccion, el editor reinyecta el markup: nos quedamos
    // solo con el ultimo (appendChild lo dejo al final) y borramos los viejos.
    var inBody = document.querySelectorAll('body > ' + sel);
    for (var i = 0; i < inBody.length - 1; i++) inBody[i].remove();
  }

  function portalCartUI() {
    ['.egl-cart-overlay', '.egl-cart-drawer', '.egl-toast'].forEach(portalToBody);
  }

  portalCartUI();
  document.addEventListener('shopify:section:load', portalCartUI);

  var WA = (document.body.getAttribute('data-egl-wa') || '56964394010').replace(/[^0-9]/g, '');

  function fmt(cents) { return '$' + Math.round(Number(cents) / 100).toLocaleString('es-CL'); }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function getWA() { return (document.body.getAttribute('data-egl-wa') || WA).replace(/[^0-9]/g, ''); }

  /* ========== Cart ==========
   * El carrito vivia solo en memoria (var cart = []), asi que al cambiar de
   * pagina el script se recargaba y volvia a cero. Ahora se guarda en
   * localStorage y se relee en cada carga.
   */
  var CART_KEY = 'egl_cart_v1';
  // El carrito guarda el precio del momento. Si el precio de un juego cambia,
  // un carrito viejo mostraria el importe viejo (el checkout de Shopify cobra
  // el correcto igual, pero la diferencia confunde). Lo caducamos a los 7 dias.
  var CART_TTL = 7 * 24 * 60 * 60 * 1000;

  function loadCart() {
    try {
      var raw = localStorage.getItem(CART_KEY);
      if (!raw) return [];

      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.items)) return [];
      if (!data.t || (Date.now() - data.t) > CART_TTL) {
        localStorage.removeItem(CART_KEY);
        return [];
      }

      // Saneamos lo leido: un localStorage corrupto o de una version vieja no
      // debe romper la pagina entera.
      return data.items.filter(function (x) {
        return x && typeof x.name === 'string' && isFinite(Number(x.price));
      }).map(function (x) {
        return {
          name: String(x.name),
          price: Number(x.price),
          img: typeof x.img === 'string' ? x.img : '',
          qty: Math.max(1, parseInt(x.qty, 10) || 1),
          variant: x.variant ? String(x.variant) : '',
          meta: typeof x.meta === 'string' ? x.meta : ''
        };
      });
    } catch (e) {
      return [];
    }
  }

  /* ── Espejo hacia el carrito real de Shopify ──────────────────────────
   * Este carrito vive en localStorage, pero /cart, el checkout y cualquier
   * app leen el carrito del servidor. Sin espejarlo, el cliente ve una cosa
   * aqui y otra distinta al pagar. Se replica el estado completo: vaciar y
   * volver a cargar es la unica forma deterministica de que queden iguales.
   */
  var syncTimer = null;

  /* Espeja el carrito local al de Shopify AHORA y avisa si lo logró.
     Devuelve una promesa para poder esperarla antes de ir al checkout. */
  function pushCart() {
    var items = [];
    for (var i = 0; i < cart.length; i++) {
      // Sin id de variante no se puede espejar: se deja el carrito del
      // servidor intacto antes que dejarlo a medias.
      if (!cart[i].variant) return Promise.resolve(false);
      items.push({ id: cart[i].variant, quantity: cart[i].qty });
    }

    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    return fetch('/cart/clear.js', { method: 'POST', headers: headers, credentials: 'same-origin' })
      .then(function () {
        if (!items.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: headers,
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });
      })
      .then(function () { return true; })
      .catch(function () { return false; });
  }

  function syncShopify() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(pushCart, 400);
  }

  function saveCart() {
    try {
      localStorage.setItem(CART_KEY, JSON.stringify({ t: Date.now(), items: cart }));
    } catch (e) {
      // Modo privado de Safari o cuota llena: el carrito sigue andando en
      // memoria, solo que no sobrevive al cambio de pagina.
    }
    syncShopify();
  }

  var cart = loadCart();

  // Al cargar la pagina tambien se espeja, para que /cart no muestre restos
  // de una sesion anterior. Si el carrito local esta vacio no se toca nada:
  // no queremos borrar algo que el cliente agrego por otro camino.
  if (cart.length) syncShopify();

  // Si el cliente tiene la tienda abierta en dos pestanas, las mantenemos en
  // sincronia: 'storage' salta en las OTRAS pestanas cuando una escribe.
  window.addEventListener('storage', function (e) {
    if (e.key !== CART_KEY) return;
    cart = loadCart();
    refreshCart();
  });

  function refreshCart() {
    // La mejora del pedido se paga, asi que entra en el total. Pero no se
    // lista ni se cuenta: la representa la perilla, y verla dos veces (fila
    // con papelera + perilla) daba dos formas distintas de sacar lo mismo.
    //
    // Se reconoce por la VARIANTE y no solo por la marca "upsell": los
    // carritos guardados antes de que existiera esa marca igual tienen que
    // dejar de mostrar la fila.
    var _upEl = document.querySelector('[data-egl-upsell]');
    var _upVid = _upEl ? String(_upEl.getAttribute('data-variant') || '') : '';
    var isUp = function (x) {
      return !!x.upsell || (_upVid !== '' && String(x.variant) === _upVid);
    };

    var count = cart.reduce(function (a, x) { return a + (isUp(x) ? 0 : x.qty); }, 0);
    var total = cart.reduce(function (a, x) { return a + x.price * x.qty; }, 0);

    document.body.classList.toggle('egl-has-items', cart.length > 0);

    document.querySelectorAll('[data-egl-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-egl-count-label]').forEach(function (el) { el.textContent = '· ' + count; });
    document.querySelectorAll('[data-egl-total]').forEach(function (el) { el.textContent = fmt(total); });

    var body = document.querySelector('[data-egl-cart-body]');
    if (body) {
      if (count === 0) {
        body.innerHTML = '<div class="egl-cart-empty"><span class="egl-cart-empty-icon"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path></svg></span><div style="font-weight:600;color:#62606e;font-size:15px">Tu carrito está vacío</div><div style="font-size:13.5px;margin-top:4px">Agrega tus juegos favoritos</div></div>';
      } else {
        var html = '';
        cart.forEach(function (x, i) {
          // Ojo: el indice "i" tiene que seguir siendo el del carrito real,
          // porque los botones +/- y la papelera lo usan para ubicar el item.
          if (isUp(x)) return;
          var cover = x.img
            ? '<img src="' + x.img + '" alt="">'
            : '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="6" y1="11" x2="10" y2="11"></line><line x1="8" y1="9" x2="8" y2="13"></line><line x1="15" y1="12" x2="15.01" y2="12"></line><line x1="18" y1="10" x2="18.01" y2="10"></line><rect x="2" y="6" width="20" height="12" rx="6"></rect></svg>';
          html +=
            '<div class="egl-cart-item">' +
            '<span class="egl-cart-item-cover">' + cover + '</span>' +
            '<div class="egl-cart-item-info">' +
            '<div class="egl-cart-item-name">' + escapeHtml(x.name) + '</div>' +
            (x.meta ? '<div class="egl-cart-item-meta">' + escapeHtml(x.meta) + '</div>' : '') +
            '<div class="egl-cart-item-price">' + fmt(x.price) + '</div>' +
            '<div class="egl-cart-item-qty">' +
            '<button type="button" class="egl-cart-qty-btn" data-egl-qty="' + i + '" data-d="-1">−</button>' +
            '<span class="egl-cart-qty-val">' + x.qty + '</span>' +
            '<button type="button" class="egl-cart-qty-btn" data-egl-qty="' + i + '" data-d="1">+</button>' +
            '</div></div>' +
            '<button type="button" class="egl-cart-item-remove" data-egl-remove="' + i + '" aria-label="Eliminar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></button>' +
            '</div>';
        });
        body.innerHTML = html;
      }
    }

    syncUpsell(cart);
    renderRecos(cart);

    document.querySelectorAll('[data-egl-checkout]').forEach(function (a) {
      var msg = 'Hola Elite Games! Quiero comprar:\n' +
        cart.map(function (x) { return '• ' + x.qty + 'x ' + x.name + ' — ' + fmt(x.price * x.qty); }).join('\n') +
        '\nTotal: ' + fmt(total);
      a.setAttribute('href', 'https://wa.me/' + getWA() + '?text=' + encodeURIComponent(msg));
    });

    // "Comprar ahora" usa un cart permalink de Shopify: /cart/{variante}:{cantidad},...
    // que arma el carrito y lleva directo al checkout. Necesita el id de la
    // variante de TODOS los items; sin el, no hay checkout posible y el boton
    // queda inerte en vez de mandar al cliente a una URL rota.
    var missingVariant = cart.some(function (x) { return !x.variant; });
    document.querySelectorAll('[data-egl-buynow]').forEach(function (a) {
      if (!cart.length || missingVariant) {
        a.classList.add('egl-disabled');
        a.removeAttribute('href');
        a.setAttribute('aria-disabled', 'true');
        a.title = missingVariant ? 'Este producto solo se puede comprar por WhatsApp' : '';
        return;
      }
      a.classList.remove('egl-disabled');
      a.removeAttribute('aria-disabled');
      a.title = '';
      var permalink = cart.map(function (x) { return x.variant + ':' + x.qty; }).join(',');
      a.setAttribute('href', '/cart/' + permalink);
    });
  }

  function addToCart(name, price, img, variant, meta, product) {
    // Agrupamos por variante cuando existe: dos variantes del mismo juego
    // (PS4 / PS5) son items distintos, no el mismo con qty 2.
    var key = variant || name;
    var i = -1;
    for (var k = 0; k < cart.length; k++) if ((cart[k].variant || cart[k].name) === key) { i = k; break; }
    if (i >= 0) {
      cart[i].qty++;
      // Carritos guardados antes de que existiera "product" no lo traen: se
      // completa al re-agregar, para que las recomendaciones funcionen igual.
      if (!cart[i].product && product) cart[i].product = String(product);
    } else {
      cart.push({ name: name, price: Number(price), img: img || '', qty: 1,
                  variant: variant || '', meta: meta || '', product: product ? String(product) : '' });
    }
    saveCart();
    refreshCart();
    showToast(name + ' agregado al carrito');
    // Se abre el carrito en cada agregado: el cliente ve lo que lleva y el
    // total, en vez de solo un toast que se va.
    document.body.classList.add('egl-cart-open');
  }

  /* ── Mejora del pedido ──────────────────────────────────────────────────
   * Un interruptor que agrega o saca un producto real del carrito. El estado
   * se lee SIEMPRE del carrito, no del propio checkbox: si el cliente lo
   * elimina desde la lista de items, la perilla vuelve sola.
   * ------------------------------------------------------------------------ */
  function syncUpsell(list) {
    var el = document.querySelector('[data-egl-upsell]');
    if (!el) return;
    var vid = el.getAttribute('data-variant');
    el.checked = list.some(function (x) { return String(x.variant) === String(vid); });
  }

  function toggleUpsell(el) {
    var vid = el.getAttribute('data-variant');
    var i = -1;
    for (var k = 0; k < cart.length; k++) if (String(cart[k].variant) === String(vid)) { i = k; break; }

    if (i >= 0) {
      cart.splice(i, 1);
    } else {
      // addToCart abre el cajon y lanza el aviso; aca ya estamos dentro del
      // cajon, asi que lo agregamos en silencio para no interrumpir.
      cart.push({
        upsell: true,   // no se lista como item: lo representa la perilla
        name: el.getAttribute('data-name') || 'Mejora',
        price: Number(el.getAttribute('data-price')) || 0,
        img: el.getAttribute('data-img') || '',
        qty: 1,
        variant: vid || '',
        meta: '',
        product: el.getAttribute('data-product') || ''
      });
    }
    saveCart();
    refreshCart();
  }

  document.addEventListener('change', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-egl-upsell]');
    if (el) toggleUpsell(el);
  });

  /* ── Complementos del carrito ───────────────────────────────────────────
   * Debajo de los items mostramos los "productos complementarios" que estan
   * configurados en Shopify (Search & Discovery). Se guia SIEMPRE por el
   * juego mas caro del carrito: es el que define la compra, y sus complementos
   * son los que mejor pegan. Si cambia cual es el mas caro, cambia la lista.
   *
   * Endpoint nativo de Shopify, sin permisos ni claves:
   *   /recommendations/products.json?product_id=X&intent=complementary
   * ------------------------------------------------------------------------ */
  var recoCache = {};
  var recoShown = null;

  function pricyItem(list) {
    // "Mas caro" por precio unitario, no por subtotal: dos copias de un juego
    // barato no deberian mandar sobre uno caro.
    var best = null;
    list.forEach(function (x) {
      if (!x.product) return;
      if (!best || Number(x.price) > Number(best.price)) best = x;
    });
    return best;
  }

  function recoCard(p) {
    var v = (p.variants && p.variants[0]) || {};
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img) img = String(img).replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_200x$1$2');
    // OJO: /recommendations devuelve el precio YA en centavos (3699000 =
    // $36.990). products.json en cambio lo manda como decimal ("36990.00").
    // Multiplicar aca daba precios x100.
    var price = Math.round(Number(v.price || 0));
    var cover = img
      ? '<img src="' + img + '" alt="" loading="lazy">'
      : '<span class="egl-reco-noimg"></span>';
    return '<div class="egl-reco-card">' +
      '<a class="egl-reco-cover" href="/products/' + p.handle + '">' + cover + '</a>' +
      '<a class="egl-reco-name" href="/products/' + p.handle + '">' + escapeHtml(p.title) + '</a>' +
      '<div class="egl-reco-foot">' +
        '<span class="egl-reco-price">' + fmt(price) + '</span>' +
      '<button type="button" class="egl-reco-add" aria-label="Agregar ' + escapeHtml(p.title) + '"' +
        ' data-egl-add' +
        ' data-name="' + escapeHtml(p.title) + '"' +
        ' data-price="' + price + '"' +
        ' data-img="' + img + '"' +
        ' data-variant="' + (v.id || '') + '"' +
        ' data-product="' + p.id + '"' +
        ' data-meta="">+</button>' +
      '</div></div>';
  }

  function skelRecos(box, n) {
    box.hidden = false;
    var bars = '';
    for (var i = 0; i < n; i++) bars += '<i></i>';
    box.innerHTML = '<div class="egl-reco-head">' +
      (box.getAttribute('data-title') || 'Suele comprarse junto') + '</div>' +
      '<div class="egl-reco-skel">' + bars + '</div>';
  }

  /* Barrita de posicion debajo de la fila. En el celular la barra nativa no
   * se ve hasta que ya estas deslizando, asi que nadie descubre que hay mas
   * tarjetas. Esta se ve siempre y muestra cuanto falta. */
  function wireScrollBar(box) {
    var list = box.querySelector('.egl-reco-list');
    var bar = box.querySelector('.egl-reco-bar');
    if (!list || !bar) return;
    var thumb = bar.firstElementChild;

    function upd() {
      // Primero mostrar y DESPUES medir: un elemento con [hidden] mide 0, y
      // preguntarle el ancho estando oculto lo dejaba oculto para siempre.
      bar.hidden = false;
      var track = bar.clientWidth;
      var max = list.scrollWidth - list.clientWidth;
      // Si entran todas, la barra sobra y confunde.
      if (max <= 2 || !track) { bar.hidden = true; return; }
      var w = Math.max(20, Math.round(track * (list.clientWidth / list.scrollWidth)));
      thumb.style.width = w + 'px';
      thumb.style.transform = 'translateX(' + ((track - w) * (list.scrollLeft / max)) + 'px)';
    }

    list.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    // Medir en el siguiente cuadro: recien pintado, los anchos todavia son 0.
    if (window.requestAnimationFrame) window.requestAnimationFrame(upd);
    else setTimeout(upd, 0);
  }

  function paintRecos(box, list) {
    if (!list || !list.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML =
      '<div class="egl-reco-head">' + (box.getAttribute('data-title') || 'Suele comprarse junto') + '</div>' +
      '<div class="egl-reco-list">' + list.map(recoCard).join('') + '</div>' +
      '<div class="egl-reco-bar"><i></i></div>';
    wireScrollBar(box);
  }

  /* Un carrito guardado antes de que el item llevara el id del producto se
   * queda sin recomendaciones para siempre. En vez de pedirle al cliente que
   * lo vacie, lo recuperamos una vez buscando por nombre y lo dejamos escrito.
   * Corre una sola vez por carga: si la busqueda no encuentra, no insiste. */
  var backfilled = false;

  function backfillProducts(list, done) {
    var pend = list.filter(function (x) { return !x.product && x.name; });
    if (!pend.length) { done(); return; }
    var left = pend.length;
    var close = function () { if (--left === 0) { saveCart(); done(); } };

    pend.forEach(function (x) {
      // El nombre guardado trae la variante entre parentesis o tras un punto
      // medio ("Juego (PS4 / Primaria)"). Para buscar sirve solo el titulo.
      var q = String(x.name).split(' (')[0].split(' · ')[0].trim();
      window.fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
                   '&resources[type]=product&resources[limit]=1')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var hit = d && d.resources && d.resources.results && d.resources.results.products;
          if (hit && hit[0] && hit[0].id) x.product = String(hit[0].id);
          close();
        })
        .catch(close);
    });
  }

  function renderRecos(list) {
    var box = document.querySelector('[data-egl-reco]');
    if (!box) return;

    var lead = pricyItem(list);
    if (!lead) {
      box.hidden = true; box.innerHTML = ''; recoShown = null;
      if (!backfilled && list.length) {
        backfilled = true;
        skelRecos(box, 2);
        backfillProducts(list, function () {
          // Si tras la busqueda sigue sin id, no hay nada que mostrar.
          if (!pricyItem(cart)) { box.hidden = true; box.innerHTML = ''; return; }
          renderRecos(cart);
        });
      }
      return;
    }

    var limit = parseInt(box.getAttribute('data-limit'), 10) || 5;
    var pid = lead.product;

    // Ya esta en pantalla la lista de ese producto: no repintamos ni volvemos
    // a pedir, que el carrito se refresca en cada +/- de cantidad.
    if (recoShown === pid && box.innerHTML) return;
    recoShown = pid;

    if (recoCache[pid]) { paintRecos(box, recoCache[pid]); return; }

    skelRecos(box, Math.min(limit, 3));
    window.fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) +
                 '&intent=complementary&limit=' + limit)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) {
          // Nada que ya este en el carrito.
          return !list.some(function (x) { return String(x.product) === String(p.id); });
        });
        recoCache[pid] = prods;
        if (recoShown === pid) paintRecos(box, prods);
      })
      .catch(function () { box.hidden = true; });
  }

  /* Permalink con TODO el carrito. /cart/{id}:{qty},... reemplaza el carrito
   * completo, asi que tiene que incluir todos los items o se pierden. */
  function cartPermalink() {
    for (var i = 0; i < cart.length; i++) if (!cart[i].variant) return '';
    if (!cart.length) return '';
    return '/cart/' + cart.map(function (x) { return x.variant + ':' + x.qty; }).join(',');
  }

  /* ========== Flechas de las hileras corredizas ========== */
  // Cada .egl-row tiene su propio scroll: las flechas mueven SOLO la hilera a
  // la que pertenecen. Antes movian la grilla entera y las dos filas viajaban
  // juntas.
  function rowOf(btn) {
    var wrap = btn.closest('.egl-rowwrap');
    return wrap ? wrap.querySelector('[data-egl-row]') : null;
  }

  // Ojo con las comillas: [data-egl-scroll=-1] sin comillas no es un selector
  // valido y querySelector lanza SyntaxError.
  function syncArrows(row) {
    var wrap = row.closest('.egl-rowwrap');
    if (!wrap) return;
    var prev = wrap.querySelector('[data-egl-scroll="-1"]');
    var next = wrap.querySelector('[data-egl-scroll="1"]');
    var max = row.scrollWidth - row.clientWidth - 2;
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-egl-scroll]');
    if (!btn) return;
    var row = rowOf(btn);
    if (!row) return;
    var dir = Number(btn.getAttribute('data-egl-scroll')) || 1;
    // 80% del ancho visible: avanza sin dejar una tarjeta a medias fuera.
    row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.8), behavior: 'smooth' });
  });

  function bindRows() {
    document.querySelectorAll('[data-egl-row]').forEach(function (row) {
      if (row.__eglRowBound) return;
      var wrap = row.closest('.egl-rowwrap');
      if (!wrap || !wrap.querySelector('[data-egl-scroll]')) return;
      row.__eglRowBound = true;
      syncArrows(row);
      row.addEventListener('scroll', function () { syncArrows(row); }, { passive: true });
      window.addEventListener('resize', function () { syncArrows(row); });
    });
  }

  bindRows();
  document.addEventListener('shopify:section:load', bindRows);

  /* ========== Toast ========== */
  var toastT = null;
  function showToast(msg) {
    var t = document.querySelector('[data-egl-toast]');
    var m = document.querySelector('[data-egl-toast-msg]');
    if (!t) return;
    if (m) m.textContent = msg;
    t.classList.add('active');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('active'); }, 2400);
  }

  /* ========== Search filter ========== */
  // Sin mayusculas ni acentos: "pokemon" tiene que encontrar "Pokémon".
  function normText(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
  }

  function filterCatalog() {
    var input = document.querySelector('[data-egl-search]');
    var grid = document.querySelector('[data-egl-best-grid]');
    if (!grid) return;
    var q = normText(input && input.value);
    var cards = grid.querySelectorAll('.egl-prod-card');
    var shown = 0;
    cards.forEach(function (c) {
      var n = normText(c.getAttribute('data-egl-name'));
      var match = !q || n.indexOf(q) > -1;
      c.classList.toggle('egl-hidden', !match);
      if (match) shown++;
    });
    var title = document.querySelector('[data-egl-catalog-title]');
    if (title) title.innerHTML = q ? 'Resultados de búsqueda' : (title.getAttribute('data-default') || 'MÁS VENDIDOS 🔥');
    var countEl = document.querySelector('[data-egl-count-display]');
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' juego' : ' juegos');
    var noRes = document.querySelector('[data-egl-noresults]');
    if (noRes) {
      if (q && shown === 0) {
        noRes.classList.add('active');
        var qEl = noRes.querySelector('[data-egl-query]');
        if (qEl) qEl.textContent = input.value.trim();
        var ctaA = noRes.querySelector('[data-egl-search-wa]');
        if (ctaA) {
          var msg = 'Hola! Busco el juego "' + input.value.trim() + '", ¿lo tienen disponible?';
          ctaA.setAttribute('href', 'https://wa.me/' + getWA() + '?text=' + encodeURIComponent(msg));
        }
      } else {
        noRes.classList.remove('active');
      }
    }
  }

  /* ========== Document-level event delegation ========== */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var addBtn = t.closest && t.closest('[data-egl-add]');
    if (addBtn) {
      e.preventDefault(); e.stopPropagation();
      addToCart(
        addBtn.getAttribute('data-name'),
        addBtn.getAttribute('data-price'),
        addBtn.getAttribute('data-img'),
        addBtn.getAttribute('data-variant'),
        addBtn.getAttribute('data-meta'),
        addBtn.getAttribute('data-product')
      );
      return;
    }
    /* "Comprar ahora" de la ficha: su href es /cart/{esta variante}:1, que
     * BORRA lo que el cliente ya tenia. Lo agregamos al carrito y armamos el
     * permalink con todo, para que al pagar aparezca el juego y los extras. */
    var buyBtn = t.closest && t.closest('[data-egp-buynow]');
    if (buyBtn && !buyBtn.classList.contains('egp-disabled')) {
      e.preventDefault();

      var scope = buyBtn.closest('.egp-buy') || document;
      var addBtn = scope.querySelector('[data-egl-add]');
      if (addBtn) {
        addToCart(
          addBtn.getAttribute('data-name'),
          addBtn.getAttribute('data-price'),
          addBtn.getAttribute('data-img'),
          addBtn.getAttribute('data-variant'),
          addBtn.getAttribute('data-meta'),
          addBtn.getAttribute('data-product')
        );
      }

      /* Nada de permalinks acá. El permalink reconstruye el carrito en el
         servidor, y la sincronización pendiente (que empieza con /cart/clear)
         llegaba después y lo vaciaba: el checkout quedaba sin items y Shopify
         devolvía al inicio. Ahora se espeja primero, se espera, y recién se
         va al checkout con el carrito ya armado. */
      if (syncTimer) { clearTimeout(syncTimer); syncTimer = null; }

      buyBtn.style.pointerEvents = 'none';
      buyBtn.style.opacity = '.7';

      pushCart().then(function (ok) {
        if (ok && cart.length) {
          window.location.href = '/checkout';
          return;
        }
        // Si no se pudo espejar (algún item sin variante o falló la red),
        // se cae al permalink, que es el camino que ya funcionaba antes.
        window.location.href = cartPermalink() || buyBtn.getAttribute('href') || '/cart';
      });
      return;
    }

    var toggleBtn = t.closest && t.closest('[data-egl-cart-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      document.body.classList.toggle('egl-cart-open');
      return;
    }
    var menuBtn = t.closest && t.closest('[data-egl-menu-toggle]');
    if (menuBtn) {
      e.preventDefault();
      var open = document.body.classList.toggle('egl-menu-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var mnavLink = t.closest && t.closest('[data-egl-mnav-link]');
    if (mnavLink) {
      document.body.classList.remove('egl-menu-open');
      /* no preventDefault: dejamos que el link navegue */
    }
    var qtyBtn = t.closest && t.closest('[data-egl-qty]');
    if (qtyBtn) {
      var idx = Number(qtyBtn.getAttribute('data-egl-qty'));
      var d = Number(qtyBtn.getAttribute('data-d'));
      if (cart[idx]) {
        cart[idx].qty += d;
        if (cart[idx].qty <= 0) cart.splice(idx, 1);
        saveCart();
        refreshCart();
      }
      return;
    }
    var rmBtn = t.closest && t.closest('[data-egl-remove]');
    if (rmBtn) {
      var ri = Number(rmBtn.getAttribute('data-egl-remove'));
      cart.splice(ri, 1);
      saveCart();
      refreshCart();
      return;
    }
    var revPrev = t.closest && t.closest('[data-egl-reviews-prev]');
    var revNext = t.closest && t.closest('[data-egl-reviews-next]');
    if (revPrev || revNext) {
      var track = document.querySelector('[data-egl-reviews]');
      if (track) track.scrollBy({ left: revPrev ? -360 : 360, behavior: 'smooth' });
      return;
    }
    var goCat = t.closest && t.closest('[data-egl-go-catalog]');
    if (goCat) {
      e.preventDefault();
      var dst = document.getElementById('mas-vendidos') || document.querySelector('[data-egl-best-grid]');
      if (dst) dst.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  });

  /* ========== Input listener (delegated via input event) ========== */
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-egl-search]')) filterCatalog();
  });

  /* ========== FAQ single-open ========== */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('[data-egl-faq] summary');
    if (!sum) return;
    var det = sum.parentNode;
    setTimeout(function () {
      document.querySelectorAll('[data-egl-faq] details[open]').forEach(function (d) {
        if (d !== det) d.removeAttribute('open');
      });
    }, 0);
  });

  /* ========== Initial paint ========== */
  refreshCart();
  filterCatalog();
})();

/* ============================================================
   Reveal on scroll — elementos con .egl-reveal aparecen al entrar
   en viewport. Se re-observa el contenido inyectado por el editor.
   ============================================================ */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function showAll(root) { (root || document).querySelectorAll('.egl-reveal').forEach(function (e) { e.classList.add('egl-in'); }); }
  if (reduce || !('IntersectionObserver' in window)) { showAll(); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('egl-in'); io.unobserve(en.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  function scan(root) { (root || document).querySelectorAll('.egl-reveal:not(.egl-in)').forEach(function (e) { io.observe(e); }); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.addEventListener('load', function () { scan(); });
})();
